
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thankyoupage-registro",
      function () {
        return require("private-next-pages/thankyoupage-registro/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thankyoupage-registro"])
      });
    }
  